import { Stack, Typography } from "@mui/material";
import { ExternalLink } from "Components/Shared/ExternalLink";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Campaigns.Campaign;

type Props = {
  header?: string | null;
  description: string;
  linkUrl?: string | null;
  linkName?: string | null;
  headerFontSize?: string;
};

export const CampaignDetails = ({
  header,
  description,
  linkUrl,
  linkName,
  headerFontSize,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack alignItems="center" textAlign="center" gap={3}>
      <Typography
        variant="h4"
        component="h1"
        fontWeight="bold"
        fontSize={headerFontSize ?? ["1.5rem", "2rem"]}
        sx={{ wordBreak: "break-word" }}
      >
        {header || t(RESOURCES.DefaultHeader)}
      </Typography>
      <Typography variant="body1" lineHeight={1.6}>
        {description}
      </Typography>
      {linkUrl && (
        <ExternalLink
          url={linkUrl}
          text={linkName || t(RESOURCES.DefaultLearnMore)}
          isFlexBasisDisabled
        />
      )}
    </Stack>
  );
};
